// extracted by mini-css-extract-plugin
module.exports = {"violation":"jGiI4oLj","text":"__9rg2hXHt","card":"fq_nXMCO","more":"__2wc0B_c9","icon":"nsBY3S9B","menu":"BX4lF40w","source":"KEMLFD_Q","menuItem":"RDOmabqK"};